@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.recommended-indicator {
  color: var(--gray-637381);
  display: flex;
  align-items: center;
}
